export default "__VITE_ASSET__BjiDAdp9__"